(function () {
    'use strict';

    angular.module('swif.framework')
    .config(route)
    .factory('swifOpenbaseGroupsService',swifOpenbaseGroupsService)
    .controller('OpenbaseGroupsController', OpenbaseGroupsController)
    .controller('OpenbaseGroupController', OpenbaseGroupController);


    function route ($routeProvider) {
        'ngInject';
        $routeProvider.when('/configuration/groups/table_view', {
            templateUrl: 'partials/openbase/groups_table_view.html',
            controller: 'OpenbaseGroupsController',
            reloadOnSearch: false,
            resolve: {
                data: ['swifRouteService', 'swifOpenbaseGroupsService', function (route, service) {
                    return route.check().then(function () {
                        return service.resolveData();
                    });
                }]
            }
        });
    }

    /**
     * @ngdoc service
     * @name swif.openbase.swifOpenbaseGroupsService
     * @description groups manager
     * @requires swif.framework.swifFrameworkService
     **/
    function swifOpenbaseGroupsService (swif) {
        'ngInject';
        var service = {
            groupsByCode: {},
            groupsById: {},
            groupsCategoryRefs: [
                'openbase.category_opengst_profile_global', // -> is openstc ...
                //'openbase.category_opengst_profile',
                //'openstc.category_opengst_profile',
                'openresa.category_opengst_profile',
                'openstc_patrimoine.category_opengst_profile',
                'openstc_achat_stock.category_opengst_profile',
                'opengst_fluide.category_opengst_profile',
                'opengst_parcauto.category_opengst_profile',
                'opengst_public_lightning.category_opengst_profile'
            ],
            moduleByCategoryId: {},
            groupsCategoriesChoices: [],
            groupsToExclude: [
                'OFFI', 'RCPT', 'PART', 'DIRE', 'MANA', 'MANANT', 'ELU', //openbase profiles
                'HOTEL_MANA', 'HOTEL_USER', 'HOTEL_USER_INTERNAL', 'HOTEL_USER_EXT', 'APIRESA', //openresa
                'PARCAUTO_DEMANDEUR', 'PARCAUTO_SUPER_READER', 'PARCAUTO_MANAGER', 'PARCAUTO_AGENT'
            ],
            initialize: initialize,
            set_access_rights_to_groups: set_access_rights_to_groups,
            groups_id_to_access_rights: groups_id_to_access_rights,
            resolveData: resolveData
        };
        return service;

        function initialize() {
            return swif.settings.initialize().then(function () {
                var filter = {
                    limit: 0,
                    fields: ['id', 'name', 'code']
                };
                return swif.data.searchRead('group', filter)
                    .then(function (data) {
                        _.forEach(data.records, function (group) {
                            service.groupsByCode[group.code] = group;
                            service.groupsById[group.id] = group;
                        });
                        return data;
                    });
            });
        }

        function loadModuleByCategoryIds(ids) {
            ids.map((id, index) => {
                if (id) {
                    switch (service.groupsCategoryRefs[index]) {
                        case 'openbase.category_opengst_profile_global':
                            service.moduleByCategoryId[id] = 'openstc';
                            break;
                        case 'openresa.category_opengst_profile':
                            service.moduleByCategoryId[id] = 'openresa';
                            break;
                        case 'openstc_patrimoine.category_opengst_profile':
                            service.moduleByCategoryId[id] = 'openstc_patrimoine';
                            break;
                        case 'openstc_achat_stock.category_opengst_profile':
                            service.moduleByCategoryId[id] = 'openstc_achat_stock';
                            break;
                        case 'opengst_fluide.category_opengst_profile':
                            service.moduleByCategoryId[id] = 'opengst_fluide';
                            break;
                        case 'opengst_parcauto.category_opengst_profile':
                            service.moduleByCategoryId[id] = 'opengst_parcauto';
                            break;
                        case 'opengst_public_lightning.category_opengst_profile':
                            service.moduleByCategoryId[id] = 'opengst_public_lightning';
                            break;
                    }
                }
            });
        }

        function resolveData() {
            return initialize().then(function () {
                var filter = {};
                swif.data.sortOn(filter, 'name', 'ASC');
                filter.fields = ['id', 'name', 'implied_ids', 'trans_implied_ids', 'category_id', 'code'];
                swif.data.setLimit(filter, 0);
                return swif.data.getRefs(service.groupsCategoryRefs).then(function (refs) {
                    var ids = refs.filter((ref) => !!ref);
                    loadModuleByCategoryIds(refs);
                    var cfilter = {};
                    swif.data.addFilter(cfilter, 'id', 'in', ids);
                    swif.data.setLimit(cfilter, 0);
                    swif.data.searchRead('group_category', cfilter).then(function (categories) {
                        _.forEach(categories.records, function (record) {
                            record.name = swif.i18n.getString(record.name);
                        });
                        _.merge(service.groupsCategoriesChoices, categories.records);
                    });
                    swif.data.addExtraFilter(filter, 'profiles', 'category_id', 'in', ids);
                    return swif.collections.createOrUpdate('groups', 'group', filter, {location: true})
                        .then(function (collection) {
                            var data = {groups: collection};
                            service.data = data;
                            return data;
                        });
                });
            });
        }

        function set_access_rights_to_groups(access_rights, groups_id, exclude_profile) {
            if (exclude_profile === undefined) {
                exclude_profile = true;
            }
            var ids = [];
            _.forOwn(access_rights, function (value, key) {
                if (value && service.groupsByCode[key]) {
                    if (!exclude_profile || (exclude_profile && !_.contains(service.groupsToExclude, key))) {
                        ids.push(service.groupsByCode[key].id);
                    }
                }
            });
            ids = _.uniq(ids);
            swif.data.replaceObj(groups_id, ids);
        }

        function groups_id_to_access_rights(groups_id, access_rights) {
            _.forEach(groups_id, function (group_id) {
                if (group_id && service.groupsById[group_id]) {
                    if (service.groupsById[group_id].code) {
                        access_rights[service.groupsById[group_id].code] = true;
                    }
                }
            });
        }
    }

    function OpenbaseGroupsController ($scope, $location, swif, openbase, data) {
        'ngInject';
        var service = openbase.groups;
        $scope.debug = $location.search().debug ? true : false;
        $scope.groups = data.groups;
        $scope.implied_ids = {};
        $scope.callback = callback;
        $scope.preModal = preModal;
        $scope.preValidate = preValidate;
        $scope.getTransImpliedIds = getTransImpliedIds;
        $scope.getImpliedIds = getImpliedIds;
        $scope.$watch('groups.currentItem', watchCurrentItem);

        function callback (error, data) {
            $scope.groups.defaultActionCallback(error, data);
        }
        function preModal (data) {
             if (data.model) {
                if (data.model.category_id) {
                    if (!data.model._translated) {
                        data.model._translated = true;
                        data.model.category_id[1] = swif.i18n.getString(data.model.category_id[1]);
                    }
                }
             }
             if (data.action.id === 'copy') {
                delete data.model.code;
             }
        }
        function preValidate (data) {
            $scope.groups.preValidate(data);
            service.set_access_rights_to_groups(data.model._access_rights, data.model.implied_ids);
            return true;
        }
        function getTransImpliedIds (id) {
            var filter = {};
            filter.fields = ['id', 'name', 'trans_implied_ids'];
            swif.data.get('group', id, filter).then(function (group) {
                $scope.implied_ids[id] = group.trans_implied_ids;
            });
        }
        function getImpliedIds (id) {
            var filter = {};
            filter.fields = ['id', 'name', 'implied_ids'];
            swif.data.get('group', id, filter).then(function (group) {
                $scope.implied_ids[id] = group.implied_ids;
                _.forEach(group.implied_ids, function (id) {
                    $scope.getImpliedIds(id);
                });
            });
        }
        function watchCurrentItem (newV) {
            if (newV) {
                $scope.getTransImpliedIds(newV.id);
            }
        }
    }

    function OpenbaseGroupController ($scope, swif, openbase) {
        'ngInject';
        var service = openbase.groups;
        $scope.modules = swif.module.modules;
        /**
            model._access_rights = {
                openbase_configuration_menu: true / false,
                ..
            }
            model.implied_ids = [23,43, ...]
        **/
        if (!$scope.model._access_rights) {
            $scope.model._access_rights = {};
        }
        $scope.choices = {
            categories: service.groupsCategoriesChoices
        };
        $scope.set_access_rights_to_groups = function () {
            service.set_access_rights_to_groups($scope.model._access_rights, $scope.model.implied_ids);
        };
        $scope.groups_id_to_access_rights = function () {
            service.groups_id_to_access_rights($scope.model.implied_ids, $scope.model._access_rights);
        };
        $scope.groups_id_to_access_rights();
        $scope.$watch('model.category_id', (newV) => {
            if (newV) {
                $scope.model._module = service.moduleByCategoryId[newV[0]];
            } else {
                $scope.model._module = false;
            }
        });
    }

})();
